import { Typography, Button, Link, Box } from "@mui/material";
import { Flex } from "~/components/Flex";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import EmptyExceptionsImgSrc from "~/images/empty-exceptions.png";

function EmptyPendingExceptions() {
  return (
    <Flex flexDirection="column" alignItems="center">
      <CheckCircleIcon sx={{ fontSize: 48, color: "success.main" }} />
      <Typography sx={{ fontSize: 24, fontWeight: 700, textAlign: "center" }}>
        No more exceptions to review. You're all set!
      </Typography>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          color: "text.secondary",
        }}
      >
        Come back later after your colleagues have triaged more findings.
      </Typography>
      <Button color="primary" variant="outlined">
        Return to Exceptions
      </Button>
    </Flex>
  );
}

function EmptyPendingExceptionsCard() {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      minHeight={"100%"}
      justifyContent="center"
      gap={1}
    >
      <CheckCircleIcon sx={{ fontSize: 24, color: "success.main" }} />
      <Typography sx={{ fontSize: 18, fontWeight: 700, textAlign: "center" }}>
        No exceptions to review. You're all set!
      </Typography>
      {/* <Typography sx={{ fontSize: 14, fontWeight: 400, textAlign: "center", color: "text.secondary" }}>Come back later after your colleagues have triaged more findings.</Typography> */}
    </Flex>
  );
}

function EmptyExpiringExceptionsCard() {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      minHeight={"100%"}
      justifyContent="center"
      gap={1}
    >
      <CheckCircleIcon sx={{ fontSize: 24, color: "success.main" }} />
      <Typography sx={{ fontSize: 18, fontWeight: 700, textAlign: "center" }}>
        No exceptions are expiring soon. You're all set!
      </Typography>
      {/* <Typography sx={{ fontSize: 14, fontWeight: 400, textAlign: "center", color: "text.secondary" }}>Come back later after your colleagues have triaged more findings.</Typography> */}
    </Flex>
  );
}

function EmptyExceptionsList() {
  const docsLink = ""; // TODO: need an exceptions docs link
  return (
    <Flex
      width="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        component="img"
        src={EmptyExceptionsImgSrc}
        width={"100%"}
        alt="Empty exceptions illustration"
      />
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        maxWidth="600px"
        gap={1}
      >
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: 700,
            lineHeight: "32px",
            textAlign: "center",
          }}
        >
          Time to create your first exception!
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "24px",
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          Exceptions are part of the security triage process. They let you
          disable or risk accept checks, CVEs, and advisories that aren't
          important to your business. You create exceptions as you explore
          findings in your infrastructure.
        </Typography>
        {docsLink && (
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 400,
              lineHeight: "24px",
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            To learn more read the{" "}
            <Link href={docsLink} target="_blank">
              Mondoo Documentation
            </Link>
            .
          </Typography>
        )}
      </Flex>
    </Flex>
  );
}

export {
  EmptyPendingExceptions,
  EmptyPendingExceptionsCard,
  EmptyExpiringExceptionsCard,
  EmptyExceptionsList,
};
